import { render, staticRenderFns } from "./ConcretoPedidoGet.vue?vue&type=template&id=6f243634&scoped=true"
import script from "./ConcretoPedidoGet.vue?vue&type=script&lang=js"
export * from "./ConcretoPedidoGet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f243634",
  null
  
)

export default component.exports